import { Injectable } from '@angular/core';
import { LogoutSubscriber } from 'shared/services/subscribers/logout-subscriber.service';
import { WorkItemDiscussion } from '../models/work-item-discussion';

@Injectable()
export class DiscussionList {
  private _discussionWorkItemList: WorkItemDiscussion[] = [];

  constructor(logoutSubscriber: LogoutSubscriber) {
    logoutSubscriber.subscribe(this.resetDiscussions.bind(this));
  }

  public get activeDiscussionWorkItemList(): WorkItemDiscussion[] {
    return this._discussionWorkItemList;
  }

  public get discussionWorkItemCount(): number {
    return this._discussionWorkItemList.length;
  }

  public getDiscussionItemById(id: string): WorkItemDiscussion {
    return this._discussionWorkItemList.find(item => item.ItemID === id);
  }

  public resetDiscussions(): void {
    this._discussionWorkItemList.length = 0;
  }
}
